import { useState } from 'react'
import './Pages.css'
import './Members.css'

const members = [
    {
        name: 'Scott Augustine',
        chair: 'Soprano',
        image: '/images/members/Scott.webp',
        imageScale: 1.3,
        imagePosition: '30% 10%',
        bio: `Scott Augustine is a Houston-based classical saxophone artist and educator. In 2022, Augustine completed a Doctorate of Musical Arts at the University of Illinois Urbana-Champaign. Augustine joined the adjunct faculty at Lone Star College - Montgomery in 2023 and maintains a private lesson studio in the Greater Houston area. Augustine is the soprano chair of the Kazoku Quartet, a saxophone ensemble that brings music of all genres to the audiences of Houston.

            Augustine has received multiple awards in chamber music performance, earning the silver medal alongside the Khroma Quartet at the 2019 Fischoff National Chamber Music Competition, winning the American Prize in Chamber Music Performance for 2019-2020 with Khroma, and winning first place with the Versa Quartet in the 2020 North American Saxophone Alliance's Quartet Competition. Augustine has also been invited to give quartet recitals at the Navy Band International Saxophone Symposium in 2017 as well as the Midwest Clinic in 2018. In 2022, Augustine was awarded first place in the panamerican Clari-Sax Yucatán Henri Selmer Competition held in Mérida, Mexico.

            Major ensembles that Augustine has performed with include the Houston Ballet Orchestra, The Woodlands Symphony, the Brazos Valley Symphony Orchestra, and the Bay Area Philharmonic. Augustine has given masterclasses at Youngstown State University, Hiram College, and Sam Houston State University. In the Spring of 2025, Augustine filled in for the Professor of Saxophone at Sam Houston State University.

            Living in Houston, Augustine is surrounded by many family members and fulfills the arduous duties of an uncle and dog caretaker. He is also joined by his dear friends who make it worth battling the Texas heat for.`
    },
    {
        name: 'Dan Gelok',
        chair: 'Alto',
        image: '/images/members/Dan.webp',
        imageScale: 1.4,
        imagePosition: 'center 45%', 
        bio: `Saxophonist Dan Gelok is internationally recognized as an educator, a performer, and an innovator whose career has spanned the concert stage, the orchestra pit, and the recording studio across three continents. His playing moves fluidly between traditional classical repertoire, contemporary experimental music, and popular idioms, while continually holding audience engagement as the highest priority, regardless of setting.

            As an orchestral musician he has appeared with the Houston Symphony, Houston Ballet, and the Singapore Symphony Orchestra, and has been featured as concerto soloist with ensembles in both the United States and Singapore. He has composed multiple classical works for saxophone and mixed ensembles, focusing on repertoire that brings modern techniques into an accessible musical language. In 2019 he published Chorales for Saxophone Quartet, a collection of 23 Bach chorales arranged and annotated for the development of student ensembles.

            Gelok is the founder of the Houston Underground Competition, the country’s largest chamber music competition for student saxophonists. He holds degrees from Indiana University and the University of Massachusetts-Amherst, and for over a decade served on the saxophone faculty of the University of Houston’s Moores School of Music. Since then, he has built a successful second career in software development, bringing the same discipline and creative problem-solving to the technology industry.

            Dan currently lives in Houston with his wife and three children. He also built this website and dislikes talking about himself in third person.`,
    },
    {
        name: 'Masahito Sugihara',
        chair: 'Tenor',
        image: '/images/members/Mas.webp',
        imageScale: 1.0,
        imagePosition: 'center 60%',
        bio: `Originally from Japan, Masahito (Mas) Sugihara began playing the saxophone at age 15 and quickly fell in love with the instrument. He first came to the United States as an exchange student in 1993 and returned in 1995 to study music at Temple University. He later earned both his Master of Music and Doctor of Musical Arts degrees from Northwestern University, where he served as a lecturer for nine years. After joining the faculty at Morehead State University in 2011, Mas accepted a position at Sam Houston State University in 2013, where he currently serves as Professor of Saxophone.

            Chamber music has always been at the heart of his performing career. He currently performs with the Kazoku Quartet and Awea Duo (flute and saxophone), and regularly appears as an orchestral saxophonist with the Houston Symphony and Houston Ballet Orchestra.

            Mas lives in Houston's Independence Heights neighborhood with his wife, Elizabeth, and their mini Bernedoodle, Bento. He remains grateful for the opportunities music has provided and the remarkable people it has brought into his life.`
    },
    {
        name: 'Evan Withner',
        chair: 'Baritone',
        image: '/images/members/Evan2.webp',
        imagePosition: 'center 10%',
        imageScale: 1.7,
        bio: `Evan Withner is a Houston-based saxophonist, educator, and arts administrator. As an active classical, jazz, and contemporary chamber performer, he has achieved nationwide distinction through his competitive endeavors, and performing as the baritone saxophone player of the Kazoku Quartet. He has been a guest performer with Houston’s contemporary music ensemble Musiqa, with performances spanning prominent local venues such as MATCH and the Contemporary Arts Museum Houston.

            Evan spent over a decade fine-tuning saxophone pedagogy and arts administration as an owner of The Young Saxophonist’s Institute, an organization that has opened numerous camps and reached hundreds of students throughout Texas. Through this, he has been a fierce advocate for contemporary composers and new music, helping to commission a collection of new works for saxophone ensemble. Evan holds a Bachelor of Music degree from the University of Houston with emphasis in music education and performance.`
    },
]

const extendedMembers = [
    { name: 'Seth McAdow', image: '/images/members/Seth.webp', imageScale: 1.2, imagePosition: '50% 50%' },
    { name: 'Ellie Parker', image: '/images/members/Ellie.webp', imageScale: 2.7, imagePosition: '60% 25%'},
    { name: 'Johnny Salinas', image: '/images/members/Johnny2.webp', imageScale: 2.1, imagePosition: '50% top' },
    { name: 'Nick Bissen', image: '/images/members/Nick.webp', imageScale: 1.8, imagePosition: '50% 20%' },
    { name: 'Matt Singletary', image: '/images/members/Matt.webp' },
    { name: 'Grace Estrada', image: '/images/members/Grace.webp', imageScale: 1.5, imagePosition: '50% 10%' },
]

function MemberCard({ name, chair, image, bio, imagePosition, imageScale }) {
    const [expanded, setExpanded] = useState(false)
    const imgStyle = {
        ...(imagePosition && { objectPosition: imagePosition, transformOrigin: imagePosition }),
        ...(imageScale && { transform: `scale(${imageScale})` }),
    }

    return (
        <div
            className={`member-card ${expanded ? 'expanded' : ''}`}
            onClick={() => setExpanded(!expanded)}
        >
            <div className="member-photo-wrap">
                <img
                    src={image}
                    alt={name}
                    className='member-photo'
                    style={Object.keys(imgStyle).length ? imgStyle : undefined}
                />
            </div>
            <h2 className='member-name'>{name}</h2>
            {chair && <h3 className='member-chair'>{chair}</h3>}
            <p className='member-bio'>{bio}</p>
        </div>
    )
}

function Members() {
    return (
        <div className="page">
            <h1>Current Members</h1>
            <div className='members-grid'>
                {members.map(({ name, chair, image, bio, imagePosition, imageScale }) => (
                    <MemberCard key={name} name={name} chair={chair} image={image} bio={bio} imagePosition={imagePosition} imageScale={imageScale} />
                ))}
            </div>

            <h1 className="extended-heading">Extended Family</h1>
            <p className="extended-subtitle">Friends, Former Members, and People We Love</p>
            <div className='extended-grid'>
                {extendedMembers.map(({ name, image, imagePosition, imageScale }) => (
                    <div className="extended-card" key={name}>
                        <div className="extended-photo-wrap">
                            <img
                                src={image}
                                alt={name}
                                className="extended-photo"
                                style={{
                                    ...(imagePosition && { objectPosition: imagePosition, transformOrigin: imagePosition }),
                                    ...(imageScale && { transform: `scale(${imageScale})` }),
                                }}
                            />
                        </div>
                        <h2 className="extended-name">{name}</h2>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Members
